var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerFireStationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#CC0000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000, 25.000) scale(0.025000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.82-150.77q-43.67 0-74.05-30.51-30.39-30.51-30.39-74.1h-30.76q-26.66 0-45.64-18.99Q80-293.35 80-320v-200h440v-135.38q0-26.66 18.98-45.64T584.62-720H660v-20q0-13.73 9.29-23.02t23.02-9.29h15.38q13.73 0 23.02 9.29T740-740v20h24.31q21 0 37.96 12.06 16.96 12.07 23.42 32.17L877-523.84q1.77 5.3 2.38 10.3.62 5 .62 10.39v247.77h-95.38q0 43.59-30.57 74.1-30.57 30.51-74.23 30.51-43.67 0-74.05-30.51-30.39-30.51-30.39-74.1H384.62q0 43.84-30.57 74.23-30.57 30.38-74.23 30.38Zm.18-40q27 0 45.81-18.81 18.81-18.8 18.81-45.42t-18.81-45.81Q307-320 280-320q-27 0-45.81 19.19-18.81 19.19-18.81 45.81t18.81 45.42Q253-190.77 280-190.77Zm400 0q27 0 45.81-18.81 18.81-18.8 18.81-45.42t-18.81-45.81Q707-320 680-320q-27 0-45.81 19.19-18.81 19.19-18.81 45.81t18.81 45.42Q653-190.77 680-190.77ZM120-480v160q0 10.77 6.92 17.69 6.93 6.93 17.7 6.93h41q10.84-29 36.53-46.81Q247.85-360 280-360q32.15 0 57.85 17.81 25.69 17.81 36.53 46.81H520V-480H120Zm440 184.62h25.62q10.84-29 36.53-46.81Q647.85-360 680-360q32.15 0 57.85 17.81 25.69 17.81 36.53 46.81H840V-480H560v184.62ZM560-520h276l-47.85-143.08q-2.3-7.69-8.84-12.3-6.54-4.62-15-4.62H584.62q-10.77 0-17.7 6.92-6.92 6.93-6.92 17.7V-520ZM80-560v-35.38h40v-89.24H80V-720h375.38v35.38h-40v89.24h40V-560H80Zm75.38-35.38H250v-89.24h-94.62v89.24Zm130 0H380v-89.24h-94.62v89.24ZM520-480H120h400Zm40 0h280-280Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerFireStationIcon);
export default __webpack_public_path__ + "static/media/marker-fire-station-icon.f71354459073513764d47219ee050066.svg";
export { ForwardRef as ReactComponent };